
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ModalProvider } from './components/ui/ModalProvider';
import { initSentry } from './lib/sentry';
import * as Sentry from '@sentry/react';

// Initialiser Sentry AVANT tout le reste
initSentry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// Composant de fallback pour l'ErrorBoundary
const ErrorFallback = ({ error, resetError }: { error: Error; resetError: () => void }) => (
  <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
    <div className="max-w-xl w-full bg-white rounded-2xl shadow-2xl p-8 border-t-4 border-red-500 text-center">
      <h2 className="text-2xl font-bold text-slate-900 mb-2">Une erreur est survenue</h2>
      <p className="text-slate-500 mb-6">
        L'application a rencontré une erreur inattendue. L'erreur a été signalée à l'équipe technique.
      </p>
      <button 
        onClick={resetError}
        className="bg-slate-900 text-white px-6 py-3 rounded-lg font-bold hover:bg-slate-800 transition-colors w-full"
      >
        Réessayer
      </button>
    </div>
  </div>
);

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={ErrorFallback}
      beforeCapture={(scope) => {
        // Ajouter des informations supplémentaires avant la capture
        scope.setContext('react_error_boundary', {
          timestamp: new Date().toISOString(),
        });
      }}
    >
      <ModalProvider>
        <App />
      </ModalProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
